import { apiRequest } from '../../api/client';

export async function fetchAdminSetupAvailable() {
  const data = await apiRequest('/api/admin/auth/setup-available');
  return Boolean(data?.available);
}
